// @mui material components
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import breakpoints from "assets/theme/base/breakpoints";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Loader from "examples/Loader";
import { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import { Card, Typography } from "@mui/material";
import businessIcon from "../../../../assets/themeIcons/business.svg";
import viewsIcon from "../../../../assets/themeIcons/views.svg";
import reviewsIcon from "../../../../assets/themeIcons/reviews.svg";
import favouritIcon from "../../../../assets/themeIcons/consumers.svg";
import StatisticsChart from "./data/components/StatisticsChart";
import homeShadowIcon from "../../../../assets/themeIcons/shadow-home.svg";
import reviewShadowIcon from "../../../../assets/themeIcons/shadow-reviews.svg";
import heartShadowIcon from "../../../../assets/themeIcons/shadow-heart.svg";

function Default() {
  const { values } = breakpoints;
  const [loader, setLoader] = useState(false);
  const [agency] = useAgencyInfo();
  const activities = useAgencyInfo()[5];
  const AppService = useAppServices();

  const [accountCount, setAccountCount] = useState(0);
  const [followersCount, setFollowersCount] = useState(0);
  const [claimRequests, setClaimRequests] = useState(0);
  const [claimRequestsApproved, setClaimRequestsApproved] = useState(0);
  const [claimRequestsPending, setClaimRequestsPending] = useState(0);
  const [favourits, setFavourits] = useState(0);
  const [reviews, setReviews] = useState(0);
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: [],
  });

  console.log(graphData, "graphData");

  const [premiumAccountCount, setPremiumAccountCount] = useState(0);

  const [graphFilter, setGraphFilter] = useState("hours");

  const getAccountCount = async () => {
    setLoader(true);
    const response = await AppService.accounts.get({
      query: `agency_id=${agency?._id}&tags=business`,
    });
    if (response?.response?.success) {
      setAccountCount(response?.response?.data?.length);
      setFavourits(response?.response?.favourits?.length || 0);
    }

    setLoader(false);
  };

  const getAccountPremiumCount = async () => {
    setLoader(true);
    const response = await AppService.accounts.get({
      query: `agency_id=${agency?._id}&plan_type=premium&tags=business`,
    });
    if (response?.response?.success) {
      setPremiumAccountCount(response?.response?.data?.length);
    }

    setLoader(false);
  };

  const getFollowersCount = async () => {
    setLoader(true);
    const response = await AppService.followBusiness.Get({
      query: `agency_id=${agency?._id}`,
    });

    if (response?.response?.success) {
      setFollowersCount(response?.response?.data?.length);
    }

    setLoader(false);
  };

  // claim_business
  const getClaimRequests = async () => {
    setLoader(true);
    const response = await AppService.claim_business.Get({
      query: `agency_id=${agency?._id}`,
    });

    if (response?.response?.success) {
      const claimData = response?.response?.data || [];
      const weeklyGraphData = getWeeklyData(claimData); // Get weekly data for claims
      setGraphData(weeklyGraphData); // Set graph data for the chart
    }
    setLoader(false);
  };

  const getClaimRequestsApproved = async () => {
    setLoader(true);
    const response = await AppService.claim_business.Get({
      query: `agency_id=${agency?._id}&status=approved`,
    });
    if (response?.response?.success) {
      setClaimRequestsApproved(response?.response?.data?.length);
    }
    setLoader(false);
  };

  const getClaimRequestsPending = async () => {
    setLoader(true);
    const response = await AppService.claim_business.Get({
      query: `agency_id=${agency?._id}&status=pending`,
    });

    if (response?.response?.success) {
      setClaimRequestsPending(response?.response?.data?.length);
    }

    setLoader(false);
  };

  const getWeeklyData = (claimData) => {
    const groupedData = {
      approved: {},
      pending: {},
    };

    const today = new Date();
    const last7Days = Array.from({ length: 7 }, (_, i) => {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      return formatDate(date);
    }).reverse();

    // Initialize grouped data
    last7Days.forEach((day) => {
      groupedData.approved[day] = 0;
      groupedData.pending[day] = 0;
    });

    // Group data by status and date
    claimData.forEach((claim) => {
      const claimDate = formatDate(new Date(claim.createdAt));
      if (last7Days.includes(claimDate) && groupedData.hasOwnProperty(claim.status)) {
        groupedData[claim.status][claimDate] += 1;
      }
    });

    // Prepare data for chart
    const labels = last7Days;
    const approvedData = last7Days.map((day) => groupedData.approved[day] || 0);
    const pendingData = last7Days.map((day) => groupedData.pending[day] || 0);

    return {
      labels: labels,
      datasets: [
        {
          label: "Approved",
          data: approvedData,
          backgroundColor: "#1BC4BD",
          borderRadius: 6,
          barThickness: 40,
        },
        {
          label: "Pending",
          data: pendingData,
          backgroundColor: "#E5EAEE",
          borderRadius: 6,
          barThickness: 40,
        },
      ],
    };
  };

  // Function to format a date to 'YYYY-MM-DD'
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getWeekNumber = (date) => {
    const startDate = new Date(date.getFullYear(), 0, 1);
    const days = Math.floor((date - startDate) / (24 * 60 * 60 * 1000));
    return Math.ceil((days + 1) / 7);
  };
  // reviews
  const getReviews = async () => {
    setLoader(true);
    const response = await AppService.reviews.get({
      query: `agency_id=${agency?._id}`,
    });

    if (response?.response?.success) {
      setReviews(response?.response?.data?.length);
    }

    setLoader(false);
  };

  useEffect(() => {
    getAccountCount();
    getFollowersCount();
    getClaimRequests();
    getClaimRequestsApproved();
    getClaimRequestsPending();
    getReviews();
    getAccountPremiumCount();
  }, []);

  useEffect(() => {
    // get graph data according to filter
  }, [graphFilter]);

  const handleGraphFilter = (filter) => {
    setGraphFilter(filter);
  };

  return loader ? (
    <Loader />
  ) : (
    <PageLayout>
      <SoftBox>
        <Grid container>
          <Grid item xs={12} lg={12}>
            <SoftBox mb={3} display="flex" alignItems="center" gap={2}>
              <SoftTypography
                variant={window.innerWidth < values.sm ? "h3" : "h2"}
                textTransform="capitalize"
                fontWeight="600"
              >
                General
              </SoftTypography>
            </SoftBox>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 3,
                    padding: "20px 40px",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <div>
                    <Typography variant="body2" color="#181A20">
                      All Listings
                    </Typography>
                    <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={"36px"}>
                      {accountCount || 0}
                    </Typography>
                  </div>
                  <div
                    style={{
                      width: 75,
                      height: 75,
                      backgroundColor: "#f5f5f5",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img style={{ verticalAlign: "sub" }} width={"40px"} src={businessIcon} />
                  </div>
                </Card>
                {/* <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Directory Visits", fontWeight: "bold" }}
                    count={agency?.traffic || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: "paid" }}
                  />
                </SoftBox>
                <MiniStatisticsCard
                  bgColor="white"
                  color="dark"
                  title={{ text: "Approved Requests", fontWeight: "bold" }}
                  count={claimRequestsApproved || 0}
                  percentage={{ color: "success", text: "" }}
                  icon={{ color: "info", component: "public" }}
                /> */}
              </Grid>
              <Grid item xs={12} sm={3}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 3,
                    padding: "20px 40px",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <div>
                    <Typography variant="body2" color="#181A20">
                      Total Views
                    </Typography>
                    <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={"36px"}>
                      {agency?.traffic || 0}
                    </Typography>
                  </div>
                  <div
                    style={{
                      width: 75,
                      height: 75,
                      backgroundColor: "#f5f5f5",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img style={{ verticalAlign: "sub" }} width={"40px"} src={viewsIcon} />
                  </div>
                </Card>
                {/* <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "New Signups", fontWeight: "bold" }}
                    count={accountCount || 0}
                    percentage={{ color: "error", text: "" }}
                    icon={{ color: "info", component: "emoji_events" }}
                  />
                </SoftBox>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Pending Requests", fontWeight: "bold" }}
                    count={claimRequestsPending || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{
                      color: "info",
                      component: "shopping_cart",
                    }}
                  />
                </SoftBox> */}
              </Grid>
              <Grid item xs={12} sm={3}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 3,
                    padding: "20px 40px",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <div>
                    <Typography variant="body2" color="#181A20">
                      Total Visitor Reviews
                    </Typography>
                    <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={"36px"}>
                      {reviews || 0}
                    </Typography>
                  </div>
                  <div
                    style={{
                      width: 75,
                      height: 75,
                      backgroundColor: "#f5f5f5",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img style={{ verticalAlign: "sub" }} width={"40px"} src={reviewsIcon} />
                  </div>
                </Card>
                {/* <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "New Followers", fontWeight: "bold" }}
                    count={followersCount || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: "paid" }}
                  />
                </SoftBox>
                <MiniStatisticsCard
                  bgColor="white"
                  color="dark"
                  title={{ text: "New Reviews", fontWeight: "bold" }}
                  count={reviews || 0}
                  percentage={{ color: "success", text: "" }}
                  icon={{ color: "info", component: "public" }}
                /> */}
              </Grid>
              <Grid item xs={12} sm={3}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 3,
                    padding: "20px 40px",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <div>
                    <Typography variant="body2" color="#181A20">
                      Total Favorites
                    </Typography>
                    <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={"36px"}>
                      {favourits || 0}
                    </Typography>
                  </div>
                  <div
                    style={{
                      width: 75,
                      height: 75,
                      backgroundColor: "#f5f5f5",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img style={{ verticalAlign: "sub" }} width={"40px"} src={favouritIcon} />
                  </div>
                </Card>
                {/* <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Claim Requests", fontWeight: "bold" }}
                    count={claimRequests || 0}
                    percentage={{ color: "error", text: "" }}
                    icon={{ color: "info", component: "emoji_events" }}
                  />
                </SoftBox>
                <SoftBox mb={3}>
                  <MiniStatisticsCard
                    bgColor="white"
                    color="dark"
                    title={{ text: "Premium Business", fontWeight: "bold" }}
                    count={premiumAccountCount || 0}
                    percentage={{ color: "success", text: "" }}
                    icon={{
                      color: "info",
                      component: "shopping_cart",
                    }}
                  />
                </SoftBox> */}
              </Grid>
            </Grid>

            {/* Second row boxes */}
            <Grid container spacing={3} mt={2} sx={{ display: "flex", alignItems: "stretch" }}>
              {/* First Column - Bar Chart */}
              <Grid item xs={12} sm={9}>
                <Card
                  sx={{
                    padding: "20px 40px",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                    minHeight: "600px", // Minimum height
                    maxHeight: "1000px", // Maximum height
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="body2" color="#181A20" fontWeight={600} fontSize={"16px"}>
                      Business Requests
                    </Typography>
                    {/* <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        fontSize={'14px'}
                        color={graphFilter === 'hours' ? '#181A20' : '#717171'}
                        sx={{
                          cursor: 'pointer',
                          position: 'relative',
                          display: 'inline-block',
                          fontSize: '16px',
                          fontWeight: '500',
                          '&::after': {
                            content: '""',
                            display: 'block',
                            width: '100%',
                            height: '3px',
                            backgroundColor: `${graphFilter === 'hours' ? '#181A20' : '#fff'}`,
                            marginTop: '0',
                            fontWeight: 'bold',
                          },
                        }}
                        onClick={() => {
                          handleGraphFilter('hours');
                        }}
                      >
                        Hours
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        fontSize={'14px'}
                        color={graphFilter === 'weekly' ? '#181A20' : '#717171'}
                        sx={{
                          cursor: 'pointer',
                          position: 'relative',
                          display: 'inline-block',
                          fontSize: '16px',
                          fontWeight: '500',
                          '&::after': {
                            content: '""',
                            display: 'block',
                            width: '100%',
                            height: '3px',
                            backgroundColor: `${graphFilter === 'weekly' ? '#181A20' : '#fff'}`,
                            marginTop: '0',
                            fontWeight: 'bold',
                          },
                        }}
                        onClick={() => {
                          handleGraphFilter('weekly');
                        }}
                      >
                        Weekly
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        fontSize={'14px'}
                        color={graphFilter === 'monthly' ? '#181A20' : '#717171'}
                        sx={{
                          cursor: 'pointer',
                          position: 'relative',
                          display: 'inline-block',
                          fontSize: '16px',
                          fontWeight: '500',
                          '&::after': {
                            content: '""',
                            display: 'block',
                            width: '100%',
                            height: '3px',
                            backgroundColor: `${graphFilter === 'monthly' ? '#181A20' : '#fff'}`,
                            marginTop: '0',
                            fontWeight: 'bold',
                          },
                        }}
                        onClick={() => {
                          handleGraphFilter('monthly');
                        }}
                      >
                        Monthly
                      </Typography>
                    </div> */}
                  </div>
                  <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <StatisticsChart graphData={graphData} />
                  </div>
                </Card>
              </Grid>

              {/* Second Column - Scrollable Content */}
              <Grid item xs={12} sm={3}>
                <Card
                  sx={{
                    padding: "20px 30px",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                    overflow: "auto",
                    maxHeight: "968px",
                    "@media (max-width: 1600px)": {
                      maxHeight: "600px",
                    },
                  }}
                >
                  <div>
                    <Typography variant="body2" color="#181A20" fontWeight={600} fontSize={"15px"}>
                      Recent Activities
                    </Typography>
                  </div>

                  {/* activity list */}
                  {activities?.map((item) => (
                    <Card
                      key={item?._id}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "start",
                        p: 3,
                        gap: "20px",
                        padding: "20px 0",
                        boxShadow: "none",
                      }}
                    >
                      <div
                        style={{
                          width: 40,
                          height: 40,
                        }}
                      >
                        <img
                          style={{ verticalAlign: "sub" }}
                          width={"40px"}
                          src={item?.type === "business" ? homeShadowIcon : heartShadowIcon}
                        />
                      </div>
                      <div>
                        <Typography
                          variant="body2"
                          color="#181A20"
                          fontWeight={400}
                          fontSize={"14px"}
                        >
                          {item?.activity}
                        </Typography>
                      </div>
                    </Card>
                  ))}
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

export default Default;
